import axios from 'axios';
const backendUrl = `https://formbot-a0ti.onrender.com`;

export const addFolder = async ({ name }) => {
  try {
    await axios.post(`${backendUrl}/addfolder`, { name });
    return true;
  } catch (error) {
    console.log(error);
    alert("Something went wrong");
  }
};

export const getAllFolders = async () => {
  try {
    const response = await axios.get(`${backendUrl}/folders`);
    return response.data.folders;
  } catch (error) {
    console.log(error);
    alert("Something went wrong");
  }
};

export const getFormByFolder = async (folderName) => {
  try {
    const response = await axios.get(`${backendUrl}/forms/${folderName}`);
    return response.data.forms;
  } catch (error) {
    console.log(error);
    alert("Something went wrong");
  }
};



export const addForm = async (data) => {
  try {

    const response = await axios.post(`${backendUrl}/addform`, data);
    return response.data;
  } catch (error) {
    console.error('Error saving form data', error);
    throw error;
  }
};


export const getFormById = async ({id}) => {
    try {
      const response = await axios.get(`${backendUrl}/getForm/${id}`);
      return response.data.forms;
    } catch (error) {
      console.log(error);
      alert("Something went wrong");
    }
  };
export const getResponsesByFormId = async (id) => {
    try {
      const response = await axios.get(`${backendUrl}/getResponse/${id}`);
      return response.data;
    } catch (error) {
      console.log(error);
      alert("Something went wrong");
    }
  };
export const getFormdataByFormId = async (id) => {
    try {
      const response = await axios.get(`${backendUrl}/getFormdata/${id}`);
      return response.data;
    } catch (error) {
      console.log(error);
      alert("Something went wrong");
    }
  };
  

export const incrementViews = async (formid) => {
  const formid2=formid.id;
  //console.log(formid2);
  try {
    await fetch(`${backendUrl}/${formid2}/increment-views`, {
      method: 'POST',
    });
  } catch (error) {
    console.error('Error incrementing view count:', error);
  }
};
export const updateTheme = async (formid,color1) => {
  const formid2=formid;
  const color=color1;
  console.log(formid2);
  try {
    await fetch(`${backendUrl}/${formid2}/${color}/theme`, {
      method: 'POST',
    });
  } catch (error) {
    console.error('Error Updating Theme:', error);
  }
};

export const deleteFormById = async (id) => {
    try {
       await axios.get(`${backendUrl}/deleteForm/${id}`);
      
    } catch (error) {
      console.log(error);
      alert("Something went wrong");
    }
  };
export const deleteFolderById = async (id) => {
    try {
       await axios.get(`${backendUrl}/deleteFolder/${id}`);
      
    } catch (error) {
      console.log(error);
      alert("Something went wrong");
    }
  };

  export const saveFormResponse = async (data) => {
    try {
      const response = await axios.post(`${backendUrl}/saveFormResponse`,data );
      return response.data;
    } catch (error) {
      console.error('Error saving response:', error);
      throw error;
    }
  };
  export const updateFormResponse = async (_id,responseData) => {
    try {
      
      const response = await axios.post(`${backendUrl}/updateFormResponse`,{_id,responseData} );
      
      return response.data;
    } catch (error) {
      console.error('Error saving response:', error);
      throw error;
    }
  };
